/*
 * O mínimo do chat que mora no pacote principal: a tradução e as permissões
 * do `canelaChat`. O resto (store, gaveta, barra lateral) só desce quando o
 * chat está ligado para o leitor (ver index.tsx).
 */
import app from 'flarum/forum/app';
import { t } from '../../utils/settings';
/** Tradução do chat (`ramon-canela.forum.chat.*`), já como texto. */
export function ct(key, params = {}) {
  return t(`chat.${key}`, params);
}
export function caps() {
  return app.forum?.attribute('canelaChat') || {
    enabled: false
  };
}

/** O chat aparece para o leitor: ligado no admin, logado e com permissão. */
export function chatOn() {
  const c = caps();
  return !!(c.enabled && c.canUse && app.session.user);
}
flarum.reg.add('ramon-canela', 'forum/features/chat/flags', { ct: ct,caps: caps,chatOn: chatOn, });